module.exports = __webpack_public_path__ + "img/icon_exterior.75fc9e54.svg";